import { Component, OnInit } from '@angular/core';
import { ListaMovilesService } from 'src/app/shared/services/lista-moviles.service';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-lista-recorrido-eventos',
  templateUrl: './lista-recorrido-eventos.component.html',
  styleUrls: ['./lista-recorrido-eventos.component.scss']
})
export class ListaRecorridoEventosComponent implements OnInit {

  resumenListado:any = [];

  constructor(
    public listamovilesservice: ListaMovilesService,
    public gtp: Gtp,
  ) { }

  ngOnInit(): void {   
    this.loadData(); 
  }

  loadData(){    
    this.resumenListado = (this.listamovilesservice.resumenListado).eventos;
    this.listamovilesservice.getResumenRecorrido().subscribe(data => {     
      this.resumenListado = data.eventos;
    });
  }

  showPosition(i){    
    this.listamovilesservice.setPositionRecorrido(i);
  }

  changeTab(){
    this.listamovilesservice.sideResumen('posiciones');
  }

}
